'use strict';

import ReactDOM from 'react-dom';
import React from 'react';
import VastPlayer from '../../src/vast-player.js';
import axios from 'axios';

const videoOptions = {
  disableControls: true,
};

function alertFinished() {
  alert('Video Finished');
}

axios.get('../../test/data/multi-ad.xml').then((xml) => (
    ReactDOM.render(
      <VastPlayer
        height={1080}
        width={1920}
        vastXml={xml.data}
        videoOptions={videoOptions}
        onEnded={alertFinished}
      />,
      document.getElementById('example')
    )
  )
);



// WEBPACK FOOTER //
// ./examples/multi-ad/multi-ad.jsx